import { useEffect, useState } from 'react'
import { AlertType } from '../../Utils/Types'
import { IoHappy, IoWarning, IoClose } from 'react-icons/io5'

type Props = {
    visible: boolean,
    message: string,
    type: AlertType,
    onCloseMessage: () => void
    
}

export const FeedbackMessage = ({ visible, message, type, onCloseMessage }: Props) => {

    let bgColor = ''
    const [progress, setProgress] = useState(0)
    const [increment, setIncrement] = useState<number>(1)
    //const [visibled, setVisibled] = useState(visible)

    const setMessageProgress = () => {
        if (visible === true) {
            const intervalo = setInterval(() => {
                setProgress((oldProgress) => { if (oldProgress > 99) { clearInterval(intervalo); /*setVisibled(false);*/ return 0 } return oldProgress + 4 })
            }, 100)
        }
    }

    useEffect(() => {

        if (increment === -1 && type === 'SUCCESS') {
            onCloseMessage()
            //setIncrement(1)
        }
    }, [increment])

    const showProgress = () => {

        setProgress(0)

        let intervalId: NodeJS.Timeout
        //const increment = 1
        // Calcula a quantidade de progresso a ser incrementada a cada 100 milissegundos
        //const increment = (100 / (5 * 1000 / 100))
        // Inicia o intervalo para incrementar o progresso
        intervalId = setInterval(() => {
            setProgress((prevProgress) => {
                const newProgress = prevProgress + 1

                // Verifica se o progresso atingiu 100% e limpa o intervalo
                if (newProgress >= 100) {
                    clearInterval(intervalId)
                    //onCloseMessage()  

                    if (type === 'SUCCESS') {
                        setIncrement(-1)
                    }

                    return 100
                }

                return newProgress
            })
        }, 12)

        // Limpa o intervalo quando o componente é desmontado
        return () => clearInterval(intervalId)
    }

    const handleCloseMessage = () => {
        onCloseMessage()
        setIncrement(1)
        setProgress(0)
    }

    useEffect(() => {

        if (visible) {
            showProgress()
        } else {
            setProgress(0)
            setIncrement(1)
        }

        //setVisibled(visible)
        //setMessageProgress()
    }, [visible])

    switch (type) {
        case 'DANGER': bgColor = 'bg-red-400'; break
        case 'WARNING': bgColor = 'bg-amber-400'; break
        case 'SUCCESS': bgColor = 'bg-emerald-600'; break
    }

    return (

        <div style={{ opacity: `${visible ? '1' : '0'}`, visibility: `${visible ? 'visible' : 'hidden'}` }}
            className={`h-auto min-w-[200px] flex flex-col fixed transition-all duration-300  top-0 right-0 rounded-md ${bgColor} mt-2 mr-2 z-50`}>

            <div className={`w-full h-full flex items-center flex-grow-1 p-4`}>
                {type === "DANGER" || type === "WARNING" &&
                    <IoWarning color='#FFF' className='mr-2' />

                }

                {type === "SUCCESS" &&
                    <IoHappy color='#FFF' className='mr-2' />
                }
                <span className={`text-white w-full text-sm`}>{message}</span>
                <button onClick={handleCloseMessage} className={`ml-2 w-8 h-8 flex justify-center items-center rounded-md ${type === "DANGER" ? 'hover:bg-red-500' : ''}`}>
                    <IoClose color='#fff' />
                </button>

            </div>

            {type === 'SUCCESS' &&

                <div className={`w-full h-1 bottom-0 rounded-br-md rounded-bl-md bg-green-900`} style={{ width: `${progress}%` }} />
            }

        </div>
    )
}